import { createSelector } from '@reduxjs/toolkit';

import type { RootState } from '@/stores/store';

export const selectEditorUIFeature = (s: RootState) => s.editor.ui;

export const selectGridEnabled = createSelector(
  [selectEditorUIFeature],
  (s) => s.grid,
);

export const selectAnnotationsEnabled = createSelector(
  [selectEditorUIFeature],
  (s) => s.annotations,
);

export const selectEditorLoading = createSelector(
  [selectEditorUIFeature],
  (s) => s.loading,
);

export const selectProjectIsLoading = createSelector(
  [selectEditorLoading],
  (l) => l.project,
);

export const selectEditingPropertyKey = createSelector(
  [selectEditorUIFeature],
  (s) => s.editingPropertyKey,
);
